import { applyVueInReact } from 'vuereact-combined';

import { default as VueDropdownRotatingArrow } from '@/components/common/RotatingArrow/DropdownRotatingArrow.vue';
import { ArrowDirection, ArrowIcons } from '@/components/common/RotatingArrow/types';

const ReactDropdownRotatingArrow = applyVueInReact(VueDropdownRotatingArrow);

export const DropdownRotatingArrow = (props: {
	icon?: ArrowIcons;
	rotate?: boolean;
	height?: number;
	width?: number;
	arrows?: { on: ArrowDirection; off: ArrowDirection };
}) => <ReactDropdownRotatingArrow {...props} />;
